import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {connect} from 'react-redux';
import {Card, Row, Col} from 'antd';
import {fetchCategoriesList} from '../../actions/categories'
import {StyledContent} from '../../styles/mixins'

class categoriesView extends Component {

  componentWillMount() {
    if (!this.props.categories.length) {
      this.props.onFetchCategoriesList()
    }
  }

  handleClick = (slug) => {
    this.props.history.push(`/categories-post/${slug}`)
  }

  render() {
    const Category = this.props.categories.find(x => x.slug === this.props.match.params.slug)

    return (
      <StyledContent>
        <Card title={Category ? Category.name : this.props.match.params.slug} bordered={false}>
          <Row>
          {
            Category && Category.categories.map((cat, i) => (
              <Col span={6} >
                <Card title={cat.name} style={{height: 200}} span={6} onClick={() => this.handleClick(cat.slug)} key={i}>
                    <p>{cat.description}</p>
                </Card>
              </Col>
            ))
          }
          </Row>
        </Card>
      </StyledContent>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  categories: state.categories.categoriesList,
})

const mapDispatchToProps = (dispatch: Function) => ({
  onFetchCategoriesList: () => {
    fetchCategoriesList(dispatch)
  },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(categoriesView))


// WEBPACK FOOTER //
// ./src/components/categories/index.js